import Uploader from "@/modules/editor/components/Uploader";
import { UploadButton } from "@/modules/editor/components/Uploader/Button";
import { LEFT_PANEL_WIDTH } from "@/utils/constants";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { Center, chakra, ChakraProps, Text, Image, Button } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { ReactNode } from "react";

interface Props {
  url?: string;
  placeholderText?: ReactNode;
  className?: string;
  uploadable?: boolean;
  setUrl?: (url: string) => void;
}
const defaultCss: ChakraProps = {
  w: `${LEFT_PANEL_WIDTH - 64 - 16 * 2}px`,
  h: `${LEFT_PANEL_WIDTH - 64 - 16 * 2}px`,
  color: "text.subtitle",
  bg: "#464646",
  my: "16px",
  maxH: "100%",
  maxW: "100%",
  flexShrink: 0,
};

const WithPlaceHolder: React.FC<Props> = ({
  placeholderText = "",
  url,
  className,
  uploadable,
  setUrl,
}) => {
  const { translate } = useTranslate();
  return (
    <Center className={className} flexDir="column" {...defaultCss}>
      {url ? (
        <Image draggable="false" src={url} objectFit="contain" maxH="100%" maxW="100%"></Image>
      ) : (
        <>
          <Text
            display="inline-flex"
            justifyContent="center"
            w="100%"
            px="16px"
            textAlign="center"
            fontSize="15px"
            whiteSpace="pre-wrap"
          >
            {placeholderText}
          </Text>
          {uploadable ? (
            <>
              <Text my="12px">{translate(Editor_Words["Or"])}</Text>
              <Uploader onUpload={setUrl}>
                <Button
                  variant="outline"
                  borderColor="text.subtitle"
                  color="text.subtitle"
                  w="150px"
                  fontSize="sm"
                  bg="transparent"
                  size="sm"
                >
                  {translate(Editor_Words["upload_image_to_board"])}
                </Button>
              </Uploader>
            </>
          ) : null}
        </>
      )}
    </Center>
  );
};

export const ImageWithPlaceHolder = chakra(observer(WithPlaceHolder));
